import { apiClient } from "./ApiConfig";

export const orderActionsApi = {
  cancelOrder: (orderId: number) => {
    return apiClient.post(`/order/${orderId}/cancel`);
  },
  markOrderReceived: (orderId: number) => {
    return apiClient.post(`/order/${orderId}/mark-received`);
  },
};

export default orderActionsApi;
